(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  function loadMore(btn) {
    var nextUrl = btn.dataset.nextUrl;
    var sectionId = btn.dataset.sectionId;
    if (!nextUrl || !sectionId) return;

    var separator = nextUrl.indexOf('?') > -1 ? '&' : '?';
    var url = nextUrl + separator + 'section_id=' + encodeURIComponent(sectionId);
    var originalText = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Loading…';

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('Request failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#CollectionProductGrid');
        var currentGrid = qs('#CollectionProductGrid');

        if (newGrid && currentGrid) {
          while (newGrid.firstChild) {
            currentGrid.appendChild(newGrid.firstChild);
          }
        }

        var newBtn = doc.querySelector('#CollectionLoadMoreBtn');
        if (newBtn && newBtn.dataset.nextUrl) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          btn.disabled = false;
          btn.textContent = originalText;
        } else {
          btn.remove();
        }

        document.dispatchEvent(new CustomEvent('products:appended'));
      })
      .catch(function (err) {
        console.error('Load more failed:', err);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  function init() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#CollectionLoadMoreBtn');
      if (!btn) return;
      loadMore(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
